import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  IAttendanceResponse,
  IMarkAttendancePayload,
  IMarkAttendanceResponse,
  IAttendanceLogsResponse,
  IAttendanceOverviewResponse,
} from "@/interface/attendance.interface";

export const AttendanceService = {
  getAttendance: async (params?: string): Promise<IAttendanceResponse> => {
    const API = `${API_ENDPOINT.attendance}${params ? `?${params}` : ""}`;
    return callApi<IAttendanceResponse>(API, { method: "GET" });
  },

  getAttendanceLogs: async (params?: string): Promise<IAttendanceLogsResponse> => {
    const API = `${API_ENDPOINT.attendance}/logs${params ? `?${params}` : ""}`;
    return callApi<IAttendanceLogsResponse>(API, { method: "GET" });
  },

  getAttendanceOverview: async (params?: string): Promise<IAttendanceOverviewResponse> => {
    const API = `${API_ENDPOINT.attendance}/overview${params ? `?${params}` : ""}`;
    return callApi<IAttendanceOverviewResponse>(API, { method: "GET" });
  },

  markAttendance: async (payload: IMarkAttendancePayload): Promise<IMarkAttendanceResponse> => {
    const API = `${API_ENDPOINT.attendance}`;
    return callApi<IMarkAttendanceResponse>(API, { method: "POST", data: payload });
  },

  updateAttendance: async (id: string, payload: IMarkAttendancePayload): Promise<IMarkAttendanceResponse> => {
    const API = `${API_ENDPOINT.attendance}/${id}`;
    return callApi<IMarkAttendanceResponse>(API, { method: "PUT", data: payload });
  },
};
